import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';
import { covidAcknowledgementFlow } from './covid-acknowledgement.flow';
import { facialRecognitionFlow } from './facial-recognition.flow';
import { printBadgeFlow } from './print-badge.flow';
import { qrCodeValidationFlow } from './qr-code-validation.flow';

export enum ReprintStep {
  Start = 'Start',
  AfterCovid = 'AfterCovid',
  ScanQr = 'ScanQr',
  AfterQrValidation = 'AfterQrValidation',
  AfterFacialRecognition = 'AfterFacialRecognition',
  PrintBadge = 'PrintBadge',
  AfterPrintBadge = 'AfterPrintBadge',
}

export const reprintFlow: CheckinWorkflow<ReprintStep> = {
  id: FlowId.Reprint,
  entry: ReprintStep.Start,
  steps: {
    [ReprintStep.Start]: {
      id: ReprintStep.Start,
      next: (variables) =>
        variables.checkinProcessConfiguration?.hasCoronavirusScreen
          ? { flow: covidAcknowledgementFlow, returnStep: ReprintStep.AfterCovid }
          : { nextStep: ReprintStep.ScanQr },
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
    [ReprintStep.AfterCovid]: {
      id: ReprintStep.AfterCovid,
      next: () => ({ nextStep: ReprintStep.ScanQr }),
    },
    [ReprintStep.ScanQr]: {
      id: ReprintStep.ScanQr,
      next: () => ({ flow: qrCodeValidationFlow, returnStep: ReprintStep.AfterQrValidation }),
      back: (variables) =>
        variables.checkinProcessConfiguration?.hasCoronavirusScreen
          ? { nextStep: ReprintStep.Start }
          : { bubble: 'back' },
      exit: () => ({ bubble: 'exit' }),
    },
    [ReprintStep.AfterQrValidation]: {
      id: ReprintStep.AfterQrValidation,
      next: (variables) =>
        variables.checkinProcessConfiguration?.hasFacialRecognition
          ? { flow: facialRecognitionFlow, returnStep: ReprintStep.AfterFacialRecognition }
          : { nextStep: ReprintStep.PrintBadge },
      back: () => ({ nextStep: ReprintStep.ScanQr }),
      exit: () => ({ bubble: 'exit' }),
    },
    [ReprintStep.AfterFacialRecognition]: {
      id: ReprintStep.AfterFacialRecognition,
      next: () => ({ nextStep: ReprintStep.PrintBadge }),
    },
    [ReprintStep.PrintBadge]: {
      id: ReprintStep.PrintBadge,
      next: () => ({ flow: printBadgeFlow, returnStep: ReprintStep.AfterPrintBadge }),
      exit: () => ({ bubble: 'exit' }),
    },
    [ReprintStep.AfterPrintBadge]: {
      id: ReprintStep.AfterPrintBadge,
      next: () => ({ complete: true }),
    },
  },
};
